import Layout from '../components/layout';

import useBnclCampaignData from '../hooks/useBnclCampaignData';
import Vouchers from '../components/vouchers';
import { Voucher } from '../types/voucher';

const BnclCampaignPage = ({ storefrontConfig, bnclCampaignId, isPreview }) => {
    const campaignData = useBnclCampaignData(bnclCampaignId);

    if (campaignData.loading || !campaignData.data) {
        return <div />;
    }

    // Filter out the offers that were created/updated within last hour as they are not available yet to be ordered.
    // This is due to the 1-hour delay in cache clearing of the product catalogue service.
    // Show offers if it's a preview mode
    if (!isPreview) {
        const currentTimestamp = new Date().getTime();
        campaignData.data.vendorCampaign.offers = campaignData.data.vendorCampaign.offers.filter(
            (offer: Voucher) => currentTimestamp - new Date(offer.lastPublishDate).getTime() > 60 * 60 * 1000
        );
    }

    return (
        <>
            <Layout storefrontConfig={storefrontConfig} campaignData={campaignData} footerData={storefrontConfig}>
                <Vouchers campaignData={campaignData.data} isPreview={isPreview} />
            </Layout>
        </>
    );
};

export default BnclCampaignPage;
